export default class ScrollManager {
  constructor() {
    const triggerEls = document.body.querySelectorAll('[data-scroll-to]');

    triggerEls.forEach(t => {
      const targetEl = document.querySelector(t.dataset.scrollTo);
      if (!targetEl) return;

      t.addEventListener('click', this.triggerClickPerformed);
    });
  }

  triggerClickPerformed(evt) {
    const targetEl = document.querySelector(evt.target.dataset.scrollTo);
    if (!targetEl) return;

    const TOP_MENU_HEIGHT = 80;
    const elementTop = targetEl.getBoundingClientRect().top;

    window.scrollTo({
      behavior: 'smooth',
      top: (elementTop - TOP_MENU_HEIGHT),
    });
  }
}
